<template>
  <div class="dashboard-root" :style="containerStyle">
    <header class="dashboard-header">
      <div class="header-content">
        <div class="header-left">
          <router-link  :to="'/dashboard'" style="cursor: pointer;">
            <div class="logo-container">
             <!-- <div class="logo-icon">💼</div> -->
              <img class="logo-icon" :src="require('../assets/viaerpwhite.png')" alt="ViaPOS Logo">
              <div>
               <h2 class="header-title">Via Retail</h2>
               </div>
            </div>
        </router-link>
        </div>
        <div class="header-right">
          <div class="profile-info" v-if="username">
            <div class="profile-icon-wrapper">
              <i class="fas fa-user"></i>
            </div>
            <span class="profile-name">{{ username }}</span>
          </div>
          <button @click="handleLogout" class="logout-btn">
            <!-- <span class="logout-icon">🚪</span> -->
            <span>Logout</span>
          </button>
        </div>
      </div>
    </header>

    <main class="dashboard-main">
      <div class="main-content">
        <MenuDropdown mode="panel" />
      </div>
    </main>
  </div>
</template>

<script>
import MenuDropdown from '../components/MenuDropdown.vue';
import commonServices from '@/shared/commonServices';
import Bg from '@/assets/2.jpg'
import axios from "axios";
export default {
  name: 'Dashboard',
  components: { MenuDropdown },
  mixins: [commonServices],
  data() {
    return {
      Bg,
      username: ''
    };
  },
  computed: {
    containerStyle() {
      if (!this.Bg) return {};
      return {
        backgroundImage: `
          url(${this.Bg})
        `,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        height: '100vh',
        overflow: 'hidden'
      };
    }
  },
  methods: {
    async getThemeImage() {
      try {
        let dataURL = this.apiURL + "ThemeImages/getThemeImage?key=home_image";
        let response = await axios.get(dataURL);
        if (response.data.status === "success" && response.data.data && response.data.data.Image) {
           let baseURL = this.apiURL.replace('api/', '');
           this.Bg = baseURL + response.data.data.Image;
        }
      } catch (error) {
        console.error("Error loading theme image:", error);
      }
    },
    handleLogout() {
      localStorage.clear();
      this.$router?.push({ name: 'login' });
    }
  },
  mounted() {
    this.username = localStorage.getItem('username') || '';
    this.getThemeImage();
  },
};
</script>

<style scoped>
.dashboard-root {
  margin-top: -26px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: linear-gradient(135deg, var(--theme-bg-start) 0%, var(--theme-bg-end) 100%);
}

.dashboard-header {
  background: var(--theme-primary);
  box-shadow: 0 4px 20px rgba(92, 107, 192, 0.3);
  position: sticky;
  top: 0;
  z-index: 100;
  backdrop-filter: blur(10px);
}

.header-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 1rem 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-right {
  display: flex;
  align-items: center;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.logo-container {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.logo-icon {
  width: 60px;
  height: 60px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  backdrop-filter: blur(10px);
  /* border: 2px solid rgba(255, 255, 255, 0.2); */
  transition: transform 0.3s ease;
}

.logo-icon:hover {
  transform: scale(1.05) rotate(5deg);
}

.header-title {
  margin: 0;
  color: white;
  font-size: 2rem;
  font-weight: 700;
  letter-spacing: -0.02em;
}

.header-subtitle {
  margin: 0;
  color: rgba(255, 255, 255, 0.85);
  font-size: 0.875rem;
  font-weight: 500;
}

.logout-btn {
  background: rgba(255, 255, 255, 0.15);
  border: 2px solid rgba(255, 255, 255, 0.2);
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 12px;
  font-size: 1.5rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}

.logout-btn:hover {
  background: rgba(255, 255, 255, 0.25);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.logout-btn:active {
  transform: translateY(0);
}

.profile-info {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  background: rgba(255, 255, 255, 0.2);
  padding: 0.5rem 1rem 0.5rem 0.5rem;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  margin-right: 1rem;
  backdrop-filter: blur(5px);
  transition: all 0.3s ease;
}

.profile-info:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.profile-icon-wrapper {
  width: 30px;
  height: 30px;
  background: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--theme-primary, #5c6bc0);
  font-size: 1.5rem;
  box-shadow: 0 2px 6px rgba(0,0,0,0.1);
}

.profile-name {
  color: white;
  font-weight: 600;
  font-size: 1.2rem;
  letter-spacing: 0.3px;
}

.logout-icon {
  font-size: 1.25rem;
}

.dashboard-main {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 2rem 1rem;
}

.main-content {
  max-width: 1400px;
  margin: 0 auto;
}

@media (max-width: 768px) {
  .header-content {
    padding: 1rem;
    flex-wrap: wrap;
    gap: 1rem;
  }

  .header-subtitle {
    font-size: 0.75rem;
  }

  .logo-icon {
    width: 48px;
    height: 48px;
    font-size: 1.5rem;
  }

  .logout-btn {
    padding: 0.625rem 1.25rem;
    font-size: 0.9rem;
  }

  .dashboard-main {
    padding: 1rem 0.5rem;
  }
}

@media (max-width: 480px) {
  .header-subtitle {
    display: none;
  }
}
</style>
